import { render } from "./CountryDashboardsVES.vue?vue&type=template&id=fa08aa08&scoped=true&ts=true"
import script from "./CountryDashboardsVES.vue?vue&type=script&lang=ts"
export * from "./CountryDashboardsVES.vue?vue&type=script&lang=ts"

import "./CountryDashboardsVES.vue?vue&type=style&index=0&id=fa08aa08&lang=scss&scoped=true"
import "./CountryDashboardsVES.vue?vue&type=style&index=1&id=fa08aa08&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa08aa08"]])

export default __exports__